import React from 'react'
import './bottomnav.css'
import { Link } from 'react-router-dom';

function BottomNav() {
    return (
        <div className="bottom-nav">
            <ul className="nav-wrapper">
                <Link to="/" ><li className="bottom-nav-item"><i className="fas fa-home"></i></li></Link>
                <Link to="/write" ><li className="bottom-nav-item"><i className="fas fa-edit"></i></li></Link>
                <Link to="/bookmarks" ><li className="bottom-nav-item"><i className="fas fa-bookmark"></i></li></Link>
                <Link to="/settings" ><li className="bottom-nav-item"><i className="fas fa-cog"></i></li></Link>
            </ul>
        </div>
    )
}

export default BottomNav
